"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SH_600000_1DAY_MINUTE = {
    "code": 0,
    "stock": [{
        "time": 150051,
        "date": 20240920,
        "symbol": "600000.sh",
        "name": "600000.sh",
        "minute": [{
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 34300,
            "amount": 208854,
            "time": 925
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 842300,
            "amount": 6986452,
            "time": 930
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 239100,
            "amount": 1979855,
            "time": 931
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 238500,
            "amount": 1975450,
            "time": 932
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 229400,
            "amount": 1812984,
            "time": 933
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 233600,
            "amount": 1865571,
            "time": 934
        }, {
            "price": 8.56,
            "open": 8.56,
            "low": 8.56,
            "high": 8.56,
            "vol": 356600,
            "amount": 2962854,
            "time": 935
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 269100,
            "amount": 2265444,
            "time": 936
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 230500,
            "amount": 1302236,
            "time": 937
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 99900,
            "amount": 842685,
            "time": 938
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 59300,
            "amount": 500289,
            "time": 939
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 63200,
            "amount": 531668,
            "time": 940
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 212900,
            "amount": 1719893,
            "time": 941
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 35600,
            "amount": 291309,
            "time": 942
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 122600,
            "amount": 1045789,
            "time": 943
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 53500,
            "amount": 406943,
            "time": 944
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 83700,
            "amount": 756913,
            "time": 945
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 134200,
            "amount": 1117808,
            "time": 946
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 73600,
            "amount": 622929,
            "time": 947
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 51300,
            "amount": 437910,
            "time": 948
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 65000,
            "amount": 552711,
            "time": 949
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 369800,
            "amount": 3134420,
            "time": 950
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 100700,
            "amount": 908116,
            "time": 951
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 53100,
            "amount": 409832,
            "time": 952
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 41400,
            "amount": 349733,
            "time": 953
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 147500,
            "amount": 1115458,
            "time": 954
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 77200,
            "amount": 598687,
            "time": 955
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 152400,
            "amount": 966408,
            "time": 956
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 43400,
            "amount": 365423,
            "time": 957
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 103600,
            "amount": 865721,
            "time": 958
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 25700,
            "amount": 218785,
            "time": 959
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 228100,
            "amount": 1746110,
            "time": 1000
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 37600,
            "amount": 306989,
            "time": 1001
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 58900,
            "amount": 508780,
            "time": 1002
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 115700,
            "amount": 1040866,
            "time": 1003
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 74500,
            "amount": 583109,
            "time": 1004
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 359600,
            "amount": 3032375,
            "time": 1005
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 133700,
            "amount": 1026193,
            "time": 1006
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 36800,
            "amount": 325032,
            "time": 1007
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 8000,
            "amount": 70749,
            "time": 1008
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 131900,
            "amount": 1101561,
            "time": 1009
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 62100,
            "amount": 490752,
            "time": 1010
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 65000,
            "amount": 601392,
            "time": 1011
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 73700,
            "amount": 653837,
            "time": 1012
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 10500,
            "amount": 88604,
            "time": 1013
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 73200,
            "amount": 620492,
            "time": 1014
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 105500,
            "amount": 854539,
            "time": 1015
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 120500,
            "amount": 1026519,
            "time": 1016
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 33700,
            "amount": 277485,
            "time": 1017
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 14300,
            "amount": 87919,
            "time": 1018
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 17500,
            "amount": 150234,
            "time": 1019
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 167700,
            "amount": 1238178,
            "time": 1020
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 86200,
            "amount": 703838,
            "time": 1021
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 53600,
            "amount": 444049,
            "time": 1022
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 41700,
            "amount": 377713,
            "time": 1023
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 51900,
            "amount": 436794,
            "time": 1024
        }, {
            "price": 8.56,
            "open": 8.56,
            "low": 8.56,
            "high": 8.56,
            "vol": 199900,
            "amount": 1687785,
            "time": 1025
        }, {
            "price": 8.56,
            "open": 8.56,
            "low": 8.56,
            "high": 8.56,
            "vol": 75900,
            "amount": 658185,
            "time": 1026
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 104400,
            "amount": 883666,
            "time": 1027
        }, {
            "price": 8.57,
            "open": 8.57,
            "low": 8.57,
            "high": 8.57,
            "vol": 468400,
            "amount": 4053111,
            "time": 1028
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 204300,
            "amount": 1659304,
            "time": 1029
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 22900,
            "amount": 231851,
            "time": 1030
        }, {
            "price": 8.56,
            "open": 8.56,
            "low": 8.56,
            "high": 8.56,
            "vol": 17100,
            "amount": 134339,
            "time": 1031
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 87800,
            "amount": 712113,
            "time": 1032
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 193900,
            "amount": 1619135,
            "time": 1033
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 29700,
            "amount": 248132,
            "time": 1034
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 21200,
            "amount": 180709,
            "time": 1035
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 17100,
            "amount": 144048,
            "time": 1036
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 32100,
            "amount": 275304,
            "time": 1037
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 29700,
            "amount": 242178,
            "time": 1038
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 87200,
            "amount": 763579,
            "time": 1039
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 104800,
            "amount": 757992,
            "time": 1040
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 79700,
            "amount": 663779,
            "time": 1041
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 36900,
            "amount": 310345,
            "time": 1042
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 62900,
            "amount": 513615,
            "time": 1043
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 42400,
            "amount": 346363,
            "time": 1044
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 9100,
            "amount": 90383,
            "time": 1045
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 34600,
            "amount": 313755,
            "time": 1046
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 18700,
            "amount": 144107,
            "time": 1047
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 71300,
            "amount": 576310,
            "time": 1048
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 47200,
            "amount": 387836,
            "time": 1049
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 25300,
            "amount": 215781,
            "time": 1050
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 84500,
            "amount": 715100,
            "time": 1051
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 58400,
            "amount": 469117,
            "time": 1052
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 39200,
            "amount": 341281,
            "time": 1053
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 29800,
            "amount": 248185,
            "time": 1054
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 43800,
            "amount": 357334,
            "time": 1055
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 19000,
            "amount": 148399,
            "time": 1056
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 22100,
            "amount": 191016,
            "time": 1057
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 66800,
            "amount": 586902,
            "time": 1058
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 89800,
            "amount": 740939,
            "time": 1059
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 68800,
            "amount": 553162,
            "time": 1100
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 38200,
            "amount": 324174,
            "time": 1101
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 37500,
            "amount": 303641,
            "time": 1102
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 47100,
            "amount": 391459,
            "time": 1103
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 37900,
            "amount": 328138,
            "time": 1104
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 54400,
            "amount": 454025,
            "time": 1105
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 83600,
            "amount": 787244,
            "time": 1106
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 54400,
            "amount": 477376,
            "time": 1107
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 168800,
            "amount": 1468905,
            "time": 1108
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 77400,
            "amount": 665818,
            "time": 1109
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 65600,
            "amount": 506289,
            "time": 1110
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 49000,
            "amount": 403681,
            "time": 1111
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 73400,
            "amount": 622291,
            "time": 1112
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 13300,
            "amount": 110607,
            "time": 1113
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 18300,
            "amount": 164189,
            "time": 1114
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 198500,
            "amount": 1679475,
            "time": 1115
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 69700,
            "amount": 601345,
            "time": 1116
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 43400,
            "amount": 364387,
            "time": 1117
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 43600,
            "amount": 371304,
            "time": 1118
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 26100,
            "amount": 221826,
            "time": 1119
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 35300,
            "amount": 307878,
            "time": 1120
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 11700,
            "amount": 99731,
            "time": 1121
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 40600,
            "amount": 333155,
            "time": 1122
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 9700,
            "amount": 82694,
            "time": 1123
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 15200,
            "amount": 129534,
            "time": 1124
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 80000,
            "amount": 666326,
            "time": 1125
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 56000,
            "amount": 404269,
            "time": 1126
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 14000,
            "amount": 119238,
            "time": 1127
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 9600,
            "amount": 80067,
            "time": 1128
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 47100,
            "amount": 415353,
            "time": 1129
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 0,
            "amount": 0,
            "time": 1130
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 197200,
            "amount": 1600853,
            "time": 1300
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 28200,
            "amount": 243132,
            "time": 1301
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 30800,
            "amount": 261947,
            "time": 1302
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 19300,
            "amount": 153946,
            "time": 1303
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 112900,
            "amount": 903560,
            "time": 1304
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 73500,
            "amount": 567062,
            "time": 1305
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 36600,
            "amount": 310916,
            "time": 1306
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 178000,
            "amount": 1205489,
            "time": 1307
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 73100,
            "amount": 601035,
            "time": 1308
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 54700,
            "amount": 465137,
            "time": 1309
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 32400,
            "amount": 308002,
            "time": 1310
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 53200,
            "amount": 438745,
            "time": 1311
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 95500,
            "amount": 797284,
            "time": 1312
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 40500,
            "amount": 331813,
            "time": 1313
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 172400,
            "amount": 1443865,
            "time": 1314
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 185600,
            "amount": 1409445,
            "time": 1315
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 149100,
            "amount": 1395148,
            "time": 1316
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 78800,
            "amount": 663035,
            "time": 1317
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 144600,
            "amount": 1159649,
            "time": 1318
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 233300,
            "amount": 1870349,
            "time": 1319
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 102000,
            "amount": 859166,
            "time": 1320
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 61800,
            "amount": 523040,
            "time": 1321
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 56500,
            "amount": 424781,
            "time": 1322
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 53000,
            "amount": 437565,
            "time": 1323
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 243000,
            "amount": 2001185,
            "time": 1324
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 12600,
            "amount": 118703,
            "time": 1325
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 179300,
            "amount": 1494055,
            "time": 1326
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 10300,
            "amount": 87299,
            "time": 1327
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 94300,
            "amount": 829967,
            "time": 1328
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 35100,
            "amount": 289887,
            "time": 1329
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 143600,
            "amount": 1220211,
            "time": 1330
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 54500,
            "amount": 460586,
            "time": 1331
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 123500,
            "amount": 1045844,
            "time": 1332
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 57600,
            "amount": 441583,
            "time": 1333
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 66200,
            "amount": 557174,
            "time": 1334
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 24500,
            "amount": 207390,
            "time": 1335
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 74700,
            "amount": 585635,
            "time": 1336
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 126300,
            "amount": 1084689,
            "time": 1337
        }, {
            "price": 8.47,
            "open": 8.47,
            "low": 8.47,
            "high": 8.47,
            "vol": 50000,
            "amount": 419660,
            "time": 1338
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 35200,
            "amount": 293479,
            "time": 1339
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 45700,
            "amount": 377959,
            "time": 1340
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 34300,
            "amount": 267132,
            "time": 1341
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 43200,
            "amount": 328950,
            "time": 1342
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 93600,
            "amount": 725672,
            "time": 1343
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 282800,
            "amount": 2417743,
            "time": 1344
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 38100,
            "amount": 397677,
            "time": 1345
        }, {
            "price": 8.44,
            "open": 8.44,
            "low": 8.44,
            "high": 8.44,
            "vol": 152000,
            "amount": 1241597,
            "time": 1346
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 125100,
            "amount": 1011957,
            "time": 1347
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 185800,
            "amount": 1497219,
            "time": 1348
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 77200,
            "amount": 633208,
            "time": 1349
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 58000,
            "amount": 482945,
            "time": 1350
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 46500,
            "amount": 331466,
            "time": 1351
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 133000,
            "amount": 1090948,
            "time": 1352
        }, {
            "price": 8.44,
            "open": 8.44,
            "low": 8.44,
            "high": 8.44,
            "vol": 89000,
            "amount": 723053,
            "time": 1353
        }, {
            "price": 8.45,
            "open": 8.45,
            "low": 8.45,
            "high": 8.45,
            "vol": 43100,
            "amount": 376768,
            "time": 1354
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 212700,
            "amount": 1740505,
            "time": 1355
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 186400,
            "amount": 1558429,
            "time": 1356
        }, {
            "price": 8.46,
            "open": 8.46,
            "low": 8.46,
            "high": 8.46,
            "vol": 181000,
            "amount": 1466767,
            "time": 1357
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 77800,
            "amount": 658286,
            "time": 1358
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 62100,
            "amount": 557804,
            "time": 1359
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 178300,
            "amount": 1453961,
            "time": 1400
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 177200,
            "amount": 1483922,
            "time": 1401
        }, {
            "price": 8.48,
            "open": 8.48,
            "low": 8.48,
            "high": 8.48,
            "vol": 204900,
            "amount": 1709305,
            "time": 1402
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 309400,
            "amount": 2632357,
            "time": 1403
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 217300,
            "amount": 1807744,
            "time": 1404
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 219900,
            "amount": 1866247,
            "time": 1405
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 143400,
            "amount": 1304987,
            "time": 1406
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 274500,
            "amount": 2352035,
            "time": 1407
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 225800,
            "amount": 1893360,
            "time": 1408
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 177400,
            "amount": 1471321,
            "time": 1409
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 263100,
            "amount": 2241618,
            "time": 1410
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 251200,
            "amount": 2180829,
            "time": 1411
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 275200,
            "amount": 2381487,
            "time": 1412
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 49800,
            "amount": 401408,
            "time": 1413
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 176000,
            "amount": 1463106,
            "time": 1414
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 160000,
            "amount": 1371085,
            "time": 1415
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 170700,
            "amount": 1420612,
            "time": 1416
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 257100,
            "amount": 2118803,
            "time": 1417
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 166700,
            "amount": 1425312,
            "time": 1418
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 281200,
            "amount": 2342652,
            "time": 1419
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 234600,
            "amount": 1998925,
            "time": 1420
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 246100,
            "amount": 2099229,
            "time": 1421
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 195800,
            "amount": 1654061,
            "time": 1422
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 222300,
            "amount": 1846723,
            "time": 1423
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 194800,
            "amount": 1681078,
            "time": 1424
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 183200,
            "amount": 1470942,
            "time": 1425
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 252500,
            "amount": 2149646,
            "time": 1426
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 283600,
            "amount": 2295434,
            "time": 1427
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 263600,
            "amount": 2161303,
            "time": 1428
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 253800,
            "amount": 2112182,
            "time": 1429
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 269100,
            "amount": 2262461,
            "time": 1430
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 158900,
            "amount": 1345114,
            "time": 1431
        }, {
            "price": 8.49,
            "open": 8.49,
            "low": 8.49,
            "high": 8.49,
            "vol": 211300,
            "amount": 1757324,
            "time": 1432
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 338000,
            "amount": 2756996,
            "time": 1433
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 277500,
            "amount": 2231436,
            "time": 1434
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 339300,
            "amount": 2843620,
            "time": 1435
        }, {
            "price": 8.5,
            "open": 8.5,
            "low": 8.5,
            "high": 8.5,
            "vol": 455900,
            "amount": 3830136,
            "time": 1436
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 418000,
            "amount": 3448675,
            "time": 1437
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 683900,
            "amount": 5731604,
            "time": 1438
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 394100,
            "amount": 3396992,
            "time": 1439
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 401400,
            "amount": 3349621,
            "time": 1440
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 431700,
            "amount": 3519875,
            "time": 1441
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 432500,
            "amount": 3720054,
            "time": 1442
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 481200,
            "amount": 4155267,
            "time": 1443
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 459800,
            "amount": 3665875,
            "time": 1444
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 281100,
            "amount": 2339529,
            "time": 1445
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 292700,
            "amount": 2482994,
            "time": 1446
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 329700,
            "amount": 2756296,
            "time": 1447
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 305200,
            "amount": 2561038,
            "time": 1448
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 345700,
            "amount": 2915399,
            "time": 1449
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 815200,
            "amount": 6549001,
            "time": 1450
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 215000,
            "amount": 1743673,
            "time": 1451
        }, {
            "price": 8.53,
            "open": 8.53,
            "low": 8.53,
            "high": 8.53,
            "vol": 506600,
            "amount": 4184572,
            "time": 1452
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 567500,
            "amount": 4675196,
            "time": 1453
        }, {
            "price": 8.52,
            "open": 8.52,
            "low": 8.52,
            "high": 8.52,
            "vol": 746700,
            "amount": 6237507,
            "time": 1454
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 767600,
            "amount": 6041182,
            "time": 1455
        }, {
            "price": 8.54,
            "open": 8.54,
            "low": 8.54,
            "high": 8.54,
            "vol": 515100,
            "amount": 4469024,
            "time": 1456
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 0,
            "amount": 0,
            "time": 1457
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 0,
            "amount": 0,
            "time": 1458
        }, {
            "price": 8.55,
            "open": 8.55,
            "low": 8.55,
            "high": 8.55,
            "vol": 0,
            "amount": 0,
            "time": 1459
        }, {
            "price": 8.51,
            "open": 8.51,
            "low": 8.51,
            "high": 8.51,
            "vol": 0,
            "amount": 47285797,
            "time": 1500
        }],
        "yclose": 8.52,
        "limitprice": {
            "max": 9.37,
            "min": 7.67
        }
    }]

    /*暴露外部用的方法*/
};exports.SH_600000_1DAY_MINUTE = SH_600000_1DAY_MINUTE;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/DayMinute/600000.sh.1day.minute.js
// module id = 322
// module chunks = 0